import React, { useState } from 'react';
import PhuHuynhChildList from '../phu-huynh-child-list';
import styles from "./PhuHuynhCSKH_V2.module.css";
import CSKHForm from './cskh-form';
import CSKHHistory from './cskh-history';
import CSKHDangKyHistory from './cskh-history-dangky';
const tabs = [
    {
        id: 0,
        text: 'Lịch sử chăm sóc',
        icon: 'blockquote'
    },
    {
        id: 1,
        text: 'Lịch sử đăng ký',
        icon: 'link'
    },
];
const PhuHuynhCSKH_V2 = ({ ts_phuhuynh_id, ts_hocsinh_id, ts_hoso_survey_id, height, onChanged, onGhiDanhSuccess, isShowDanhSachCon, isHideGhiDanh }) => {
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [changedCount, setChangedCount] = useState(0);

    const onTabsSelectionChanged = (args) => {
        if (args.name === 'selectedIndex') {
            if (args.value == 1) {
                setSelectedIndex(1);
            } else if (args.value == 0) {
                setSelectedIndex(0);
            }
        }
    }
    return (
        <>
            <div className={styles.container_form}>
                <CSKHForm ts_phuhuynh_id={ts_phuhuynh_id}
                    onGhiDanhSuccess={() => {
                        if (onGhiDanhSuccess) {
                            onGhiDanhSuccess()
                        } else {
                            setChangedCount(changedCount + 1)
                        }
                    }}
                    onSuccess={() => {
                        setChangedCount(changedCount + 1)
                        if (onChanged) {
                            onChanged()
                        }
                    }}
                    isHideGhiDanh={isHideGhiDanh ?? false}
                />
            </div>
            {isShowDanhSachCon && <div>
                <PhuHuynhChildList id={ts_phuhuynh_id}
                    hocSinhSelectedId={0}
                    countToRerender={changedCount}
                    mode="column"
                    onSelected={(hocSinhSelectedId) => {
                        // onSelectedChanged({
                        //     phuHuynhSelectedId: 0,
                        //     hocSinhSelectedId: hocSinhSelectedId,
                        //     hoSoSurveySelectedId: -1
                        // })
                    }}
                />
            </div>}

            <div className={styles.tabs}>
                <div className={styles.tab}>
                    <div className={styles.tab_caption}>
                        <i className="fas fa-headphones-alt"></i>      Lịch sử chăm sóc
                    </div>
                    <CSKHHistory
                        ts_phuhuynh_id={ts_phuhuynh_id}
                        ts_hocsinh_id={ts_hocsinh_id}
                        ts_hoso_survey_id={ts_hoso_survey_id}
                        changedCount={changedCount}
                        onChanged={() => {
                            if (onChanged) {
                                onChanged();
                            }
                        }}
                    />
                </div>
                <div className={styles.tab}>
                    <div className={styles.tab_caption}>
                        <i className="far fa-file-alt"></i>  Lịch sử đăng ký
                    </div>
                    <CSKHDangKyHistory
                        ts_phuhuynh_id={ts_phuhuynh_id}
                        ts_hocsinh_id={ts_hocsinh_id}
                        ts_hoso_survey_id={ts_hoso_survey_id}
                    />
                </div>
            </div>
            {/* <div className={styles.container}>
                <Tabs
                    dataSource={tabs}
                    selectedIndex={selectedIndex}
                    onOptionChanged={(e) => {
                        onTabsSelectionChanged(e);
                    }}
                />
                <ScrollView height={height ? height : window.innerHeight - 340}>

                    <div className={styles.tab_content}>
                        {selectedIndex == 0 &&
                            <CSKHHistory
                                ts_phuhuynh_id={ts_phuhuynh_id}
                                ts_hocsinh_id={ts_hocsinh_id}
                                ts_hoso_survey_id={ts_hoso_survey_id}
                                changedCount={changedCount}
                                onChanged={() => {
                                    if (onChanged) {
                                        onChanged();
                                    }
                                }}
                            />
                        }
                        {selectedIndex == 1 &&
                            <CSKHDangKyHistory
                                ts_phuhuynh_id={ts_phuhuynh_id}
                                ts_hocsinh_id={ts_hocsinh_id}
                                ts_hoso_survey_id={ts_hoso_survey_id}
                            />
                        }
                    </div>
                </ScrollView>
            </div> */}
        </>
    );
};

export default PhuHuynhCSKH_V2;